import Component from '../vendor/Component'

export default class CollectionClusters extends Component {
  mount() {
    this.nextSelector = '[data-collection-clusters-el="next"]'
    this.prevSelector = '[data-collection-clusters-el="prev"]'

    this.nextEl = this._elem.querySelector(this.nextSelector)
    this.prevEl = this._elem.querySelector(this.prevSelector)

    this.carouselContainer = this._elem.querySelector('[data-collection-clusters-container]')
    this.listElement = this._elem.querySelector('[data-collection-clusters-list]')
    this.slideElements = this._elem.querySelectorAll('[data-collection-clusters-item]')

    if (!this.carouselContainer || !this.listElement || this.slideElements.length === 0) return

    this.checkOverflow()
    this.setupListeners()
  }

  setupListeners() {
    this.debouncedCheckOverflow = window.BAO.Utils.debounce((e) => this.checkOverflow(e), 300)
    window.addEventListener('resize', this.debouncedCheckOverflow.bind(this))

    this.nextEl.addEventListener('click', this.setAccessibilityAttributes.bind(this))
    this.prevEl.addEventListener('click', this.setAccessibilityAttributes.bind(this))
  }

  setAccessibilityAttributes() {
    this.prevEl.setAttribute('aria-disabled', this.carousel.isBeginning)
    this.nextEl.setAttribute('aria-disabled', this.carousel.isEnd)
  }

  checkOverflow() {
    const isOverflowing = this.listElement.scrollWidth > this.listElement.clientWidth

    if (isOverflowing && !this.carousel) {
      this.setupCarousel()
    } else if (!isOverflowing && this.carousel) {
      this.destroyCarousel()
    }
  }

  setupCarousel() {
    if (!window.swiper || this.carousel) return

    this.carouselContainer.classList.add('swiper')

    this.carousel = new window.swiper(this.carouselContainer, {
      direction: 'horizontal',
      loop: false,
      slidesPerView: 'auto',
      spaceBetween: 6,
      freeMode: true,
      watchOverflow: true,
      speed: 300,
      navigation: {
        nextEl: this.nextSelector,
        prevEl: this.prevSelector,
      },
    })
  }

  destroyCarousel() {
    if (this.carousel) {
      this.carousel.destroy(true, true)
      this.carousel = null
      this.carouselContainer.classList.remove('swiper')
    }
  }

  unmount() {
    window.removeEventListener('resize', () => this.checkOverflow())
    this.destroyCarousel()
  }
}
